import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

console.log('[main.tsx] Script loaded');

// Wait for Office.js to be ready before rendering React
const initializeApp = async () => {
  try {
    if (typeof Office !== 'undefined' && Office.onReady) {
      console.log('[main.tsx] Waiting for Office.onReady...');
      await Office.onReady();
      console.log('[main.tsx] Office.js ready');
    } else {
      console.log('[main.tsx] Office.js not available, rendering anyway');
    }
  } catch (err) {
    console.error('[main.tsx] Office.onReady error:', err);
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('[main.tsx] React app rendered');
};

initializeApp();
